import { render, staticRenderFns } from "./DatasetDetails.vue?vue&type=template&id=ea138be6&scoped=true"
import script from "./DatasetDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DatasetDetails.vue?vue&type=style&index=0&id=ea138be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea138be6",
  null
  
)

export default component.exports